import { CHIP_ARTICLE_CATEGORIES } from './BlogPage.contants';

export const getCategoryColor = (categoryName: string) => {
  const category = CHIP_ARTICLE_CATEGORIES.find(
    (cat) => cat?.name === categoryName
  );
  return category ? category.color : '#4a4a4a';
};

export const normalizeCategoryName = (categoryName: string) => {
  return categoryName.replace(/\s/g, '-').toLowerCase().trim();
};
